import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
  getEducatorConnections,
  acceptEducatorConnection,
  rejectEducatorConnection,
} from '../actions/educator-connections';
import {
  fetchUserConnections,
  acceptConnection,
  destroyConnection,
  rejectConnection,
} from 'shared/actions/user-connections';
import {setNavigationAnnouncement} from 'shared/actions/accessibility-announcement';
import Connections from '../components/connections';

const mapStateToProps = ({educatorConnections, userConnections}) => ({
  userConnections,
  educatorConnections,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      acceptConnection,
      acceptEducatorConnection,
      fetchUserConnections,
      getEducatorConnections,
      destroyConnection,
      rejectConnection,
      rejectEducatorConnection,
      setNavigationAnnouncement,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Connections);
